module.exports = __webpack_public_path__ + "img/返校_1.b5c1ce73.jpg";